module.exports = __webpack_public_path__ + "img/1.Ford2019.fdd7492b.png";